import {dsvFormat} from 'd3-dsv';
import {extend, stringValue} from 'vega-util';

export function delimitedFormat(delimiter) {
  return function(data, format) {
    var delim = {delimiter: delimiter};
    return dsv(data, format ? extend(format, delim) : delim);
  };
}

export default function dsv(data, format) {
  if (format.header) {
    data = format.header
      .map(stringValue)
      .join(format.delimiter) + '\n' + data;
  }
  return dsvFormat(format.delimiter).parse(data+'');
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-loader/src/formats/dsv.js
// module id = 1404
// module chunks = 0